import * as React from 'react';
import C from 'classnames';
const sizeMapper = {
    sm: 'nav-tabs-sm',
    lg: 'nav-tabs-lg'
};
export const CardHeaderTabs = props => {
    return (React.createElement("ul", { className: C('nav', 'nav-tabs', props.size && sizeMapper[props.size], 'card-header-tabs') }, props.children));
};
//# sourceMappingURL=CardHeaderTabs.js.map